export default __webpack_public_path__ + "static/media/Ellipse 1.f4ac10b2.svg";